import * as React from 'react';
import css from './task-list.css';
import TaskContainer from 'src/components/agency-onboard/task/task';
import type {Task} from 'src/components/agency-onboard/types/side-panel-comp';


type TaskListProps = {
  tasks: {
    [key: string]: Task;
  };
  setTasks: () => unknown;
};

export default function OnboardTaskList({tasks, setTasks}: TaskListProps) {
  return (
    tasks && (
      <div className={css.taskList}>
        {Object.entries(tasks).map(([task_id, task]: [any, any]) => (
          <TaskContainer
            key={task.id}
            selectedTaskId={task.id}
            tasks={tasks}
            setTasks={setTasks}
          />
        ))}
      </div>
    )
  );
}
